import { useBillingCurrency } from "$global-providers/billing-provider/provider";
import { useCallback, useMemo } from "react";
import { penceToPounds } from "./use-convert-currency";
import useCurrencyFormat from "./use-currency-format";

/**
 * A hook for both converting pence amounts into pounds and
 * formatting the currency output
 *
 * @param {Int} amountInPence
 */
export default function useFormatPence(amountInPence, currencyInput) {
  const defaultCurrency = useBillingCurrency();
  const currency = currencyInput ?? defaultCurrency;
  const currencyFormatter = useCurrencyFormat(currency);
  return useMemo(() => {
    if (!currencyFormatter) {
      return undefined;
    }

    const amountInPounds = penceToPounds(currency, amountInPence);
    return currencyFormatter.format(amountInPounds);
  }, [amountInPence, currencyFormatter, currency]);
}

export function useFormatPenceFactory() {
  const currency = useBillingCurrency();
  const currencyFormatter = useCurrencyFormat(currency);

  return useCallback(
    (amountInPence) => {
      const amountInPounds = penceToPounds(currency, amountInPence);
      if (!currencyFormatter) {
        return undefined;
      }
      return currencyFormatter.format(amountInPounds);
    },
    [currency, currencyFormatter],
  );
}
